module.exports = __webpack_public_path__ + "static/media/AHU_Graphic.e59e3268.png";